import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'

export const Standart = styled(Link)`
  border-radius: 5px;
  font-weight: bold;
  text-decoration: none;
  display: flex;
  justify-content: center;
  &:hover {
    opacity: 0.5;
    cursor: pointer;
  }
  &:focus {
    outline: 0;
  }
  @media (max-width: 960px) {
    & {
      font-size: 14px;
    }
  }
`

const wrapperModifiers = {
  block: () => css`
    width: 100% !important;
  `
}

export const Button = styled(Standart)`
  ${({ borderColor, color, colorFont, fontSize, block, small }) => css`
    border: 1px solid var(${borderColor ? borderColor : color});
    padding: ${!!small ? '4px 6px' : '8px 12px'};
    background-color: var(${color});
    color: var(${colorFont ? colorFont : '--color-white'});
    font-size: ${`${fontSize ? fontSize : 16}px`};
    ${!!block && wrapperModifiers.block()};
  `}
`
